import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";

export default function AlertDialogSlide(props) {
    const { t } = useTranslation("translation");
    return (
        <div>
            <Dialog id="ccp_Dialog" open={props.open} keepMounted onClose={props.onClose}>
                <DialogTitle id="ccp_DialogTitle">{t("UpdateTask")}</DialogTitle>
                <DialogContent id="ccp_DialogContent">
                    <DialogContentText id="ccp_DialogContentText">{t("ActionPlannedTask")}</DialogContentText>
                </DialogContent>
                <DialogActions id="ccp_DialogActions">
                    <Button id="ccp_b" onClick={props.onClose} color="secondary" variant="contained">
                        {t("Cancel")}
                    </Button>
                    <Button id="ccp_b_1" onClick={props.pushToDetails} color="primary" variant="contained">
                        {t("Detail")}
                    </Button>
                    <Button id="ccp_b_2" onClick={props.pushToUpdate} color="primary" variant="contained">
                        {t("Edit")}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
